const areas = [
  {
    title: 'Medizinrecht',
    description:
      'Umfassende Beratung und Vertretung in allen Bereichen des Medizinrechts – von Arzthaftung über Behandlungsfehlern bis zu Krankenhausrecht und Abrechnungsfragen.',
    icon: 'ri-heart-pulse-line',
    topics: ['Arzthaftungsrecht', 'Behandlungsfehler', 'Krankenhausrecht', 'Arztrecht'],
    color: 'bg-[#1A3A52]',
    textColor: 'text-white',
    image:
      'https://public.readdy.ai/ai/img_res/a214dcf92b210dae8849cb66b496ce29.jpg',
  },
  {
    title: 'Sportrecht',
    description:
      'Spezialisierte rechtliche Begleitung für Sportler, Vereine und Verbände – von Vertragsverhandlungen über Sportschiedsgerichtsbarkeit bis zu Dopingverfahren.',
    icon: 'ri-trophy-line',
    topics: ['Sportvertragsrecht', 'Vereinsrecht', 'Verbandssanktionen', 'Sportschiedsgerichtsbarkeit'],
    color: 'bg-amber-50',
    textColor: 'text-[#1A3A52]',
    image:
      'https://readdy.ai/api/search-image?query=sports%20law%20concept%2C%20football%20and%20legal%20contract%20documents%2C%20athlete%20silhouette%20with%20legal%20scales%2C%20professional%20studio%20photography%2C%20clean%20minimal%20background%2C%20symbolic%20image%20combining%20sports%20and%20justice%2C%20warm%20neutral%20tones%2C%20elegant%20composition&width=700&height=600&seq=sports-law-1&orientation=landscape',
  },
];

export default function PracticeAreas() {
  return (
    <section id="rechtsgebiete" className="py-28 bg-white">
      <div className="max-w-7xl mx-auto px-8">
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-3 mb-4">
            <span className="w-8 h-px bg-[#1A3A52]" />
            <span className="text-[#1A3A52] text-sm font-medium tracking-widest uppercase">
              Fachgebiete
            </span>
            <span className="w-8 h-px bg-[#1A3A52]" />
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-[#1A3A52] mb-4">
            Meine <span className="text-amber-500">Rechtsgebiete</span>
          </h2>
          <p className="text-stone-500 text-lg max-w-xl mx-auto leading-relaxed">
            Als Mitglied der DAV-Arbeitsgemeinschaften für Sportrecht und Medizinrecht bringe
            ich spezialisierte Expertise in beiden Bereichen mit.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8">
          {areas.map((area) => (
            <div
              key={area.title}
              className={`rounded-3xl overflow-hidden ${area.color} group hover:scale-[1.01] transition-transform duration-300`}
            >
              <div className="h-72 overflow-hidden">
                <img
                  src={area.image}
                  alt={area.title}
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-8">
                <div
                  className={`flex items-center gap-3 mb-4 ${area.textColor}`}
                >
                  <div
                    className={`w-10 h-10 flex items-center justify-center rounded-full ${
                      area.color === 'bg-[#1A3A52]' ? 'bg-white/10' : 'bg-[#1A3A52]/10'
                    }`}
                  >
                    <i className={`${area.icon} text-lg`} />
                  </div>
                  <h3 className="text-2xl font-bold">{area.title}</h3>
                </div>

                <p
                  className={`text-base leading-relaxed mb-6 ${
                    area.color === 'bg-[#1A3A52]' ? 'text-white/75' : 'text-stone-600'
                  }`}
                >
                  {area.description}
                </p>

                <div className="flex flex-wrap gap-2">
                  {area.topics.map((topic) => (
                    <span
                      key={topic}
                      className={`px-3 py-1.5 rounded-full text-xs font-medium ${
                        area.color === 'bg-[#1A3A52]'
                          ? 'bg-white/15 text-white'
                          : 'bg-[#1A3A52]/10 text-[#1A3A52]'
                      }`}
                    >
                      {topic}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-[#F5F1E8] rounded-3xl p-8 flex flex-col lg:flex-row items-center justify-between gap-6">
          <div>
            <h3 className="text-xl font-bold text-[#1A3A52] mb-1">
              Mitglied der DAV-Arbeitsgemeinschaften
            </h3>
            <p className="text-stone-500 text-sm">
              Dr. Höftmann ist aktives Mitglied in den DAV-Arbeitsgemeinschaften für Sportrecht
              und Medizinrecht – ein Zeichen für höchste fachliche Spezialisierung.
            </p>
          </div>
          <div className="flex gap-4 shrink-0">
            <div className="flex items-center gap-2 bg-white px-5 py-3 rounded-full">
              <i className="ri-shield-check-line text-[#1A3A52]" />
              <span className="text-sm font-semibold text-[#1A3A52] whitespace-nowrap">DAV Sportrecht</span>
            </div>
            <div className="flex items-center gap-2 bg-white px-5 py-3 rounded-full">
              <i className="ri-shield-check-line text-[#1A3A52]" />
              <span className="text-sm font-semibold text-[#1A3A52] whitespace-nowrap">DAV Medizinrecht</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
